// Onboarding steps keep what the user (or the voice agent) set in local state and only save on Next. An
// agent-driven jump or Back swaps the page without that, so e.g. quiet hours set to 23:25–06:05 were gone when the
// user came back from a detour. Save the step first — best effort: a refused or failed save must never trap the user.
export async function saveBeforeLeaving(handle?: { submit?: () => Promise<unknown> } | null): Promise<void> {
  try {
    await handle?.submit?.()
  } catch {
    // ignore: moving on matters more than the save
  }
}
